import FieldConfig from "../../../proto/field-config"
import {FIELD_CONDITIONS_DATE} from "../../../conditions/date"
import FieldDate from "../../../generic/datetime/date/date"

// const debug = "FieldExpenseDate"
const debug = false

export default class FieldExpenseDate extends FieldDate {

    constructor(config:FieldConfig) {
        super(config)

        this.conditionTypes = FIELD_CONDITIONS_DATE
    }
}
